import React from 'react'
import { iconLocation as IconLocation } from 'client/icons/LocationTypes'

import type { MouseEvent, MouseEventHandler } from 'react'
import type { TopDestination as TopDestinationModel } from '@s4l/stayforlong/marketing/TopDestination'

import styles from './styles.module.css'
import classNames from 'classnames'

interface ITopDestinationProps {
  readonly item: ReturnType<TopDestinationModel['toJSON']>
  readonly onClick: MouseEventHandler<HTMLButtonElement>
}

export function TopDestination(props: ITopDestinationProps) {
  const { item, onClick } = props
  const { fullName, images, name } = item
  const hasImage = !!images?.portrait

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    onClick(e)
  }

  return (
    <li className={styles.destinationBase} data-testid="top-destination">
      <button className={styles.topDestinationBtn} type="button" onClick={handleClick}>
        <span
          className={classNames({ [styles.iconImage]: hasImage })}
          style={
            hasImage
              ? {
                  backgroundImage: `url("${process.env.NEXT_PUBLIC_CLOUDFRONT_ENDPOINT}/images/${images.portrait}")`,
                }
              : {}
          }
        >
          {!hasImage && <IconLocation size={20} />}
        </span>
        <div>
          <h5>{name}</h5>
          <p>{fullName}</p>
        </div>
      </button>
    </li>
  )
}
